import APIConfig from '../../config/api';
import { APIService } from '../axiosInstance';
import { ContactModel } from '../../typings/application/contact';

type UpdateUserPhoneNumber = {
  phoneNumber: string;
};

const contactsAPI = {
  fetchContactById: (contactId: string) => {
    return APIService.get<ContactModel>(
      `${APIConfig.crmApi}/contacts/${contactId}`,
    ).then(({ data }) => data);
  },

  updateUserPhoneNumber: (phoneNumber: string) => {
    return APIService.post<UpdateUserPhoneNumber>(
      `${APIConfig.authApi}/users/onboarding/primary-phone/change-unverified`,
      {
        phoneNumber,
      },
    ).then(({ data }) => data);
  },
};

export { contactsAPI };
